/* eslint-disable no-param-reassign */
import * as types from './mutationTypes';

function clearStorage() {
  localStorage.removeItem('t-token');
  localStorage.removeItem('t-org');
  localStorage.removeItem('t-profile');
  localStorage.removeItem('t-org-control');
}

export default {
  [types.SET_TOKEN](state, token) {
    state.token = token;
  },
  [types.CLEAR_STORAGE]() {
    clearStorage();
  },
  [types.LOGOFF]: (state) => {
    state.token = '';
    clearStorage();
  },
  [types.SET_LOGIN_ERROR](state, { hasError, message }) {
    state.error = {
      hasError,
      message,
    };
  },
  [types.CLEAR_LOGIN_ERROR](state) {
    state.error = null;
  },
  [types.SESSION_OFF](state, sessionOff) {
    state.sessionOff = sessionOff;
  },
};
